import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { get } from "lodash-es";
import { ChargeStatusTag } from "@/pages/sy/components/ChargeStatusTag";
import { getChargeStatusLabel } from "@/pages/sy/constants/chargeStatus";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const useTableData = () => {
  const columnDefs: ColDef[] = [
    {
      field: "BucketName",
      headerName: "Bucket",
      minWidth: 60,
      flex: 1,
      cellStyle: cellStyle,
      wrapText: true,
      autoHeight: true,
    },
    {
      field: "ChargeStatusCode",
      headerName: "Status",
      minWidth: 60,
      flex: 1,
      cellStyle: cellStyle,
      wrapText: true,
      autoHeight: true,
      cellRenderer: (params: ICellRendererParams) => {
        return <ChargeStatusTag code={params.value} />;
      },
    },
    {
      field: "StatusText",
      headerName: "Status Text",
      hide: true,
      suppressColumnsToolPanel: true,
      minWidth: 60,
      flex: 1,
      cellStyle: cellStyle,
      valueGetter: (params) =>
        getChargeStatusLabel(params.data.ChargeStatusCode),
    },
    {
      field: "ScheduledHeatName",
      headerName: "Scheduled",
      minWidth: 80,
      flex: 1,
      cellStyle: cellStyle,
      wrapText: true,
      autoHeight: true,
    },
    {
      field: "HeatName",
      headerName: "Charged",
      minWidth: 60,
      flex: 1,
      cellStyle: cellStyle,
      wrapText: true,
      autoHeight: true,
    },
    {
      field: "RecipeName",
      headerName: "Recipe",
      minWidth: 60,
      flex: 1,
      cellStyle: cellStyle,
      wrapText: true,
      autoHeight: true,
    },
    {
      field: "ChargeNumber",
      headerName: "Charge #",
      minWidth: 65,
      flex: 1,
      cellStyle: cellStyle,
      wrapText: true,
      autoHeight: true,
    },
    {
      field: "OpenTimestamp",
      headerName: "Open",
      minWidth: 70,
      flex: 1,
      cellStyle: cellStyle,
      wrapText: true,
      autoHeight: true,
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data.OpenTimestamp, "MM/dd HH:mm"),
    },
    {
      field: "CloseTimestamp",
      headerName: "Close",
      minWidth: 70,
      flex: 1,
      cellStyle: cellStyle,
      wrapText: true,
      autoHeight: true,
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data.CloseTimestamp, "MM/dd HH:mm"),
    },
    {
      field: "ManualTargetWeight",
      headerName: "Target",
      flex: 1,
      minWidth: 60,
      cellStyle: cellStyle,
      wrapText: true,
      autoHeight: true,
      valueGetter: (params) => get(params, "data.ManualTargetWeight", "-"),
    },
    {
      field: "OperatorName",
      headerName: "Operator",
      flex: 1,
      cellStyle: cellStyle,
      wrapText: true,
      autoHeight: true,
      hide: true,
      suppressColumnsToolPanel: false,
    },
    {
      field: "TotalWeight",
      headerName: "Loaded",
      flex: 1,
      cellStyle: (params) => {
        const loadedWeight =
          parseFloat(get(params, "data.TotalWeight", "0")) || 0;
        const targetWeight =
          parseFloat(get(params, "data.ManualTargetWeight", "0")) || 0;
        if (loadedWeight > targetWeight) {
          return {
            ...cellStyle,
            color: "#d32f2f",
          };
        }
        return cellStyle;
      },
      minWidth: 60,
      wrapText: true,
      autoHeight: true,
      valueGetter: (params) => get(params, "data.TotalWeight", "0"),
    },
  ];
  return { columnDefs };
};
